<div class="profile-container" *ngIf="userData">
  <!-- Message pour profil privé -->
  <div class="private-profile-message" *ngIf="!isOwner && userData?.privacySettings?.profileVisibility === 'private'">
    <mat-card>
      <mat-card-content>
        <div class="message-content">
          <mat-icon>lock</mat-icon>
          <h2>Profil Privé</h2>
          <p>Ce compte est privé. Suivez cet utilisateur pour voir son profil.</p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Contenu du profil -->
  <div class="profile-content" *ngIf="isOwner || userData?.privacySettings?.profileVisibility !== 'private'">
    <div class="profile-info-container">
      <div class="cover-photo">
        <img [src]="coverPhotoUrl ? coverPhotoUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf'" alt="Cover Photo" class="cover-photo-img">
        <button mat-mini-fab *ngIf="userData?.uid === currentUserId" 
                class="change-cover-btn" 
                (click)="onChangeCoverPhoto()"
                matTooltip="Changer la photo de couverture">
          <mat-icon>photo_camera</mat-icon>
        </button>
      </div>
      <div class="profile-photo">
        <div class="profile-picture">
          <img [src]="profilePhotoUrl ? profilePhotoUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" alt="Profile Photo">
          <button mat-mini-fab *ngIf="userData?.uid === currentUserId" 
                  class="change-photo-btn" 
                  (click)="onChangeProfilePhoto()"
                  matTooltip="Changer la photo de profil">
            <mat-icon>photo_camera</mat-icon>
          </button>
        </div>
        <div class="text-info" >
          <div style="font-size: 22px; font-weight: bold; color: white;"><span>{{ userData?.publicName }} </span> </div>
          <div style="color: white;"><span>{{ userData?.description}}, {{ userData?.ville }} </span></div>
        </div>
      </div>
      <div class="profile-info">
        <div class="my-row" style=" width: 40%; align-items: start; padding-top: 35px; text-align: left; padding-left: 20px; " >
        </div>
        <div class="my-row2" >
          <div mat-button *ngIf="userData?.uid != currentUserId"  class="actions"  >
            <div class="row" >
              <div class="col-4" style="display: flex; text-align: center; align-items: center; justify-content: center;">
                <!-- Bouton Suivre avec une icône -->
                <button mat-icon-button (click)="toggleFollow()" [@subscribeAnimation]="isFollowing ? 'subscribed' : 'unsubscribed'">
                  <mat-icon>{{ isFollowing ? 'person_remove' : 'person_add' }}</mat-icon>
                </button>
              </div>
              <div class="col-4" style="display: flex; text-align: center; align-items: center; justify-content: center;">
                <!-- Bouton Message avec une icône -->
                <button mat-icon-button (click)="onMessageUserOnMobile()">
                  <mat-icon>message</mat-icon>
                </button>
              </div>
              <div class="col-4" style="display: flex; text-align: center; align-items: center; justify-content: center;">
                <!-- Bouton More (menu) avec une icône -->
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openAboutSheet()">
                    <mat-icon>info</mat-icon>
                    <span>À propos</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          <button mat-button *ngIf="userData?.uid === currentUserId" (click)="onEditProfile()"  class="edit-profile-btn" style="color: white; background-color: transparent;"><mat-icon >edit</mat-icon>Modifier profil</button>
          <div class="container3" >
             <div class="row">
              <div class="col-4" style="display: flex; flex-direction: column; text-align: center;">
                <div><span>Suiveurs: </span></div>
                <div ><p> {{ followersCount }}</p></div>
              </div>
              <div class="col-4" style=" text-align: center;">
                <div><span>Suivi(e): </span></div>
                <p>{{ followingCount }}</p>
              </div>
              <div class="col-4" style="text-align: center;">
                <div><span>Publications: </span></div>
                <p>{{ postsCount }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="user-posts">
      <div class="all-user-posts">
        <app-post *ngFor="let post of userPosts" [postData]="post"></app-post>
      </div>

      <!-- Indicateur de chargement -->
      <div class="loading-container" *ngIf="isLoading">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>

      <!-- Élément déclencheur pour le chargement -->
      <div #loadMoreTrigger id="load-more-trigger"></div>
    </div>
  </div>
</div>